import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getVideoData, getMediaGroups, initUploadAccessInfo, refreshUploadAccessInfo, saveVideo, uploadFile, } from "@/api/material";
import { checkSession } from '@/api/commom';
import WangEditor from "@/components/WangEditor/index.vue";
import eventEmitter from '@/utils/eventEmitter';
const VIDEO_SOURCE_DOMAIN = "https://vod-cdn.zuowenzhitiao.com/";
let timer = null;
let VideoEdit = class VideoEdit extends Vue {
    constructor() {
        super(...arguments);
        // 视频分组
        this.groups = [
            {
                name: "全部视频",
                value: 0,
            },
        ];
        // 视频详情
        this.videoData = {
            id: "",
            name: "",
            cover: "",
            slice: '',
            filename: "",
            fileId: "",
            groupId: 0,
            coursewares: [],
            details: "",
            isCopyAllow: 1,
            isOnlineNow: 1,
            onlineTime: "",
        };
        // 当前视频文件 用于初始化视频上传器
        this.currentVideoFile = { name: '', url: '' };
        this.isCoverLoading = false; // 视频封面加载状态
        this.isSliceLoading = false; // 视频贴片加载状态
        this.isVideoUploading = false; // 视频文件上传状态
        this.isCoursewareUploading = false; // 课件资料上传状态
        this._aliUploader = null; // 阿里云上传器
        // 阿里云上传器访问权限
        this._aliAccess = {
            uploadAuth: "",
            uploadAddress: "",
            videoId: "",
        };
        this.isVideoErrorTipsVisible = false;
        this.isPrevent = false;
    }
    created() {
        const query = this.$route.query;
        this.initGroupData();
        // 传入ID视为编辑 未传入则为新增
        if (query.id) {
            this.videoData.id = this.$route.query.id;
            this.initVideoData();
        }
        eventEmitter.on('routerRapture', () => {
            return this.isPrevent ? Promise.resolve() : Promise.reject();
        });
        // 配置阿里云上传器
        const AliyunUpload = window.AliyunUpload;
        this._aliUploader = new AliyunUpload.Vod({
            userId: "1197011945138604",
            region: "cn-shanghai",
            partSize: 10485760,
            parallel: 5,
            retryCount: 3,
            retryDuration: 2,
            enableUploadProgress: true,
            onUploadstarted: this.handleVideoUploadStart,
            onUploadSucceed: this.handleVideoUploadSucceed,
            onUploadFailed: () => {
                this.$message.error("上传失败");
                this.isVideoUploading = false;
            },
            onUploadTokenExpired: () => {
                this.$message.error("上传凭证已失效");
                this.isVideoUploading = false;
            },
        });
        const t = 1 * 60 * 1000;
        timer = setInterval(() => {
            this.checkHeartbeat();
        }, t);
    }
    beforeDestroy() {
        clearInterval(timer);
    }
    async checkHeartbeat() {
        await checkSession();
    }
    // 获取分组列表
    async initGroupData() {
        const res = await getMediaGroups(2);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.groups = [
            // 默认置顶【全部视频】分组
            {
                name: "全部视频",
                value: 0,
            },
            ...data.map((group) => {
                return {
                    name: group.name,
                    value: Number(group.id),
                };
            }),
        ];
    }
    // 获取视频数据
    async initVideoData() {
        try {
            const res = await getVideoData(this.videoData.id);
            if (res.data.status !== 200)
                return;
            const data = res.data.data;
            if (!data)
                return;
            this.videoData = {
                id: data.id,
                name: data.title,
                cover: data.coverUrl,
                slice: data.pasterUrl,
                filename: data.videoName,
                fileId: data.videoId,
                groupId: Number(data.groupId),
                isCopyAllow: data.isCopy,
                isOnlineNow: data.onlineNow,
                details: data.content,
                onlineTime: data.delayedTime,
                coursewares: data.coursewares.map((courseware) => {
                    return {
                        // id: String(courseware.id),
                        name: courseware.name,
                        url: courseware.url,
                        actionType: courseware.actionType,
                    };
                }),
            };
            // 配置当前视频文件
            if (data.videoName) {
                this.currentVideoFile = { name: data.videoName, url: data.videoUrl };
            }
            if (data.content) {
                this.wangEditor.setContent(data.content);
            }
            // this._file_id_cache = data.videoId;
        }
        catch (error) { }
    }
    // 选择视频封面
    handleCoverSelect(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$message.error("图片大小不能超过 5MB!");
            return false;
        }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("封面图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    // 上传视频封面
    async handleCoverUpload(type, data) {
        const file = data.file;
        const loadingState = type === 'cover' ? 'isCoverLoading' : 'isSliceLoading';
        this[loadingState] = true;
        try {
            const res = await uploadFile({
                file,
                fileType: type === 'cover' ? 'cover' : 'paster',
                businessType: 'video',
                zt_token: UserModule.token
            }, UserModule.ssoId);
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this[loadingState] = false;
            });
            if (res.data.status !== 200) {
                const uploader = type === 'cover' ? this._coverUploader : this._sliceUploader;
                return uploader.clearFiles();
            }
            this.videoData[type] = res.data.data;
        }
        catch {
            this[loadingState] = false;
        }
    }
    // 选择视频文件
    handleVideoSelect(file) {
        const isLt5G = file.size / 1024 / 1024 / 1024 < 5;
        if (!isLt5G) {
            this.$message.error("视频文件大小不能超过 5G!");
            return false;
        }
        const isMP4 = file.type === "video/mp4";
        if (!isMP4) {
            this.$message.error("视频文件只能是MP4格式!");
            return false;
        }
        return true;
    }
    // 上传视频文件
    async handleVideoUpload(data) {
        this.isVideoUploading = true;
        const file = data.file;
        // 获取访问授权
        // const isAuth: boolean = await this.handleUploadAccessInit(file.name);
        // if (isAuth) {
        //   this._aliUploader.addFile(file, null, null, null, '{"Vod":{}}');
        //   this._aliUploader.startUpload();
        // }
        this._aliUploader.addFile(file, null, null, null, '{"Vod":{}}');
        this._aliUploader.startUpload();
    }
    // // 移除视频文件
    // private handleVideoRemove() {
    //   this.videoData.fileId = "";
    //   this.videoData.filename = "";
    // }
    // // 处理视频文件已存在时用户请求上传
    // private handleVideoExceed() {
    //   this.$message.warning("请先移除当前视频后再次尝试上传");
    // }
    // 阿里云上传器预处理（上传视频文件）
    async handleVideoUploadStart(uploadInfo) {
        //上传方式，需要根据uploadInfo.videoId是否有值（该值由SDK通过localstorage获取），调用视频点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
        //上传过程中，如果在点播控制台删除了视频，即videoId不存在了，则会产生冲突，会出现控制台不存在videoId，而浏览器存在videoId的情况，报InvalidVideo.NotFound错误。此时，需手动清除localstorage 
        const isAuth = uploadInfo.videoId ? await this.handleUploadAccess('refresh', uploadInfo.videoId) : await this.handleUploadAccess('init', uploadInfo.file.name);
        if (!isAuth) {
            this.isVideoUploading = false;
            return this._aliUploader.cleanList();
        }
        const access = this._aliAccess;
        this._aliUploader.setUploadAuthAndAddress(uploadInfo, access.uploadAuth, access.uploadAddress, access.videoId);
    }
    // 阿里云上传器上传成功（上传视频文件）
    handleVideoUploadSucceed(uploadInfo) {
        this.videoData.fileId = uploadInfo.videoId;
        this.videoData.filename = uploadInfo.file.name;
        this.currentVideoFile = {
            name: uploadInfo.file.name,
            url: `${VIDEO_SOURCE_DOMAIN}${uploadInfo.object}`
        };
        this.$message.success("上传成功");
        this.isVideoUploading = false;
        this.isVideoErrorTipsVisible = false;
    }
    // 获取阿里云授权
    // type init(with videoName) refresh(with videoId)
    async handleUploadAccess(type, token) {
        const res = type === 'init'
            ? await initUploadAccessInfo(token)
            : await refreshUploadAccessInfo(token);
        if (res.data.status !== 200)
            return false;
        const data = res.data.data;
        if (!data)
            return false;
        this._aliAccess = {
            uploadAuth: data.uploadAuth,
            uploadAddress: data.uploadAddress,
            videoId: data.videoId,
        };
        return true;
    }
    handleVideoError() {
        if (!this.currentVideoFile.url)
            return;
        this.isVideoErrorTipsVisible = true;
    }
    // 选择视频关联课件
    handleCoursewareSelect(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
            this.$message.error("课件资料大小不能超过 20MB!");
            return false;
        }
        // const isPPT =
        //   file.type === "application/vnd.ms-powerpoint" ||
        //   file.type ===
        //   "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        const isPDF = file.type === "application/pdf";
        // const isDOC = file.type === "application/msword" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        // const isJPG = file.type === "image/jpeg";
        // const isPNG = file.type === "image/png";
        if (!isPDF) {
            this.$message.error("课件资料只能是PDF格式!");
            return false;
        }
        return true;
    }
    // 上传视频关联课件
    async handleCoursewareUpload(data) {
        this.isCoursewareUploading = true;
        const file = data.file;
        try {
            const res = await uploadFile({
                file,
                fileType: 'courseware',
                businessType: 'video',
                zt_token: UserModule.token
            }, UserModule.ssoId);
            this.isCoursewareUploading = false;
            if (res.data.status !== 200)
                return;
            this.videoData.coursewares.push({
                name: file.name,
                url: res.data.data,
                actionType: 2,
            });
        }
        catch (error) {
        }
    }
    // 移除视频关联课件
    handleCoursewareRemove(file) {
        const idx = this.videoData.coursewares.findIndex((courseware) => courseware.name === file.name);
        if (idx === -1)
            return;
        this.videoData.coursewares.splice(idx, 1);
    }
    // 预览视频关联课件
    previewCourseware(file) {
        window.open(file.url, "_blank");
    }
    // 保存视频数据
    async saveVideoData() {
        const video = this.videoData;
        if (video.cover === "") {
            return this.$message.error("请上传封面图");
        }
        if (video.name === "") {
            return this.$message.error("视频标题不能为空");
        }
        if (video.fileId === "") {
            return this.$message.error("视频文件不能为空");
        }
        if (video.isOnlineNow === 0) {
            if (!video.onlineTime)
                return this.$message.error("定时上架时间不能为空");
            if (new Date(video.onlineTime) < new Date())
                return this.$message.error("定时上架时间不能为小于当前时间");
        }
        const data = {
            id: video.id,
            title: video.name,
            coverUrl: video.cover,
            pasterUrl: video.slice,
            content: video.details,
            videoName: video.filename,
            videoId: video.fileId,
            videoUrl: this.currentVideoFile.url.replace(VIDEO_SOURCE_DOMAIN, ''),
            coursewares: video.coursewares.map(
            // 过滤掉el-upload生成的字段
            (courseware) => {
                return {
                    name: courseware.name,
                    url: courseware.url,
                    actionType: courseware.actionType,
                };
            }),
            groupId: `${video.groupId}`,
            isCopy: video.isCopyAllow,
            onlineNow: video.isOnlineNow,
            delayedTime: video.onlineTime,
        };
        try {
            const res = await saveVideo(data);
            if (res.data.status !== 200)
                return;
            this.$message.success("保存成功");
            this.isPrevent = true;
            setTimeout(() => {
                this.$router.push({ path: "/data-manager/video" });
            }, 300);
        }
        catch (error) {
        }
    }
};
tslib_1.__decorate([
    Ref()
], VideoEdit.prototype, "_coverUploader", void 0);
tslib_1.__decorate([
    Ref()
], VideoEdit.prototype, "_sliceUploader", void 0);
tslib_1.__decorate([
    Ref()
], VideoEdit.prototype, "wangEditor", void 0);
VideoEdit = tslib_1.__decorate([
    Component({
        name: "VideoEdit",
        components: {
            "wangEditor": WangEditor,
        },
    })
], VideoEdit);
export default VideoEdit;
